import { Icon } from "@vds/icons";
import { Modal, ModalBody, ModalTitle } from "@vds/modals";
import { Title } from "@vds/typography";
import React from "react";
import { AutomaticColibrationText, AutomaticColibrationYes, AutomaticColibrationNo, ColibrationHeadingYes, ColibrationHeadingNo} from "../../global/components/OnboardingFormStyles/Styles";

const AutomaticCalibrationModal = ({ showModal, setShowModal}) => {

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <Modal 
      width="47vw"
      opened={showModal}
      onOpenedChange={(opened) => {
        if (!opened) {
          handleCloseModal();
        }
      }}
      disableOutsideClick={true}
      ariaLabel="subscribe modal"
      closeButton={
        <div
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "25px",
            top: "25px",
          }}
        >
          <Icon name="close" />
        </div>
      }
    >
      <div>
          <ModalTitle>
            <Title size="large">
            Automatic calibration guidelines
            </Title>
          </ModalTitle>
          <ModalBody>
            <AutomaticColibrationYes>
              <ColibrationHeadingYes>Yes</ColibrationHeadingYes> 
              <div className="row">
              <div className="col-6">
                <img src={require("../../images/manypeople.jpg")}/>
                <AutomaticColibrationText><span><img style={{marginTop:"-5px", marginRight:"5px"}} src={require("../../images/green-right.png")}/></span>
                <span>Many people in view of the stream at varying distances from the camera</span></AutomaticColibrationText>
              </div>
              <div className="col-6">
              <img src={require("../../images/singleperson-moving.jpg")}/>
              <AutomaticColibrationText><span><img style={{marginTop:"-5px", marginRight:"5px"}} src={require("../../images/green-right.png")}/></span>
              <span>Single person moving around to different areas and distances from stream view.</span></AutomaticColibrationText>
              </div>
              </div>
            </AutomaticColibrationYes>
            <AutomaticColibrationNo>
             <ColibrationHeadingNo>No</ColibrationHeadingNo>
             <div className="row">
              <div className="col-6">
                <img src={require("../../images/severalpeople-samedistance.jpg")}/>
                <AutomaticColibrationText><span><img style={{marginTop:"-5px", marginRight:"5px"}} src={require("../../images/orange-right.png")}/></span>
                <span>Several people, but all at same distance from camera in same area of stream view.</span></AutomaticColibrationText>
              </div>
              <div className="col-6">
              <img src={require("../../images/singleperson.jpg")}/>
              <AutomaticColibrationText><span><img style={{marginTop:"-5px", marginRight:"5px"}} src={require("../../images/orange-wrong.png")}/></span>
              <span>Single person not in motion.</span></AutomaticColibrationText>
              </div>
              </div>
            </AutomaticColibrationNo>
          </ModalBody>
        </div>
      </Modal>
    );
  };

export default AutomaticCalibrationModal;
